import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { CreatedRes, ErrorRes } from '@/hooks/common';
import { axiosInstance } from '@/utils/axios';
import useAxiosErrorHandler from '@/hooks/useAxiosErrorHandler';

export type CompanyCreateReq = {
  name: string;
};

export type CompanyCreateRes = CreatedRes;

const useCompanyCreateMutation = () => {
  const axiosErrorHandler = useAxiosErrorHandler();
  return useMutation<CompanyCreateRes, AxiosError<ErrorRes>, CompanyCreateReq>(
    async (req: CompanyCreateReq): Promise<CompanyCreateRes> => {
      return (
        await axiosInstance()
          .post<CompanyCreateRes>('/company/create', req)
          .catch((error: AxiosError) => {
            axiosErrorHandler(error);
            throw error;
          })
      ).data;
    }
  );
};

export default useCompanyCreateMutation;
